'use strict';

var ConfigurationFoCityAptsDirective = function ConfigurationFoCityAptsDirective() {
  return {
    restrict: 'E',
    controller: 'ConfigurationFoCityAptsController',
    template: require('../templates/configuration-fo-cityapts.html'),
    link: function link($scope, element) {
      $scope.isValidationMessage = function () {
        var validationMessageCssDisplay = element.find('.jqx-grid-validation').css('display');
        return validationMessageCssDisplay && validationMessageCssDisplay !== 'none';
      };
    }
  };
};
ConfigurationFoCityAptsDirective.$inject = [];
module.exports = ConfigurationFoCityAptsDirective;